import {environment} from '../../environments/environment';

export const webServiceConfig = {
    webServiceUrl: environment.webServiceUrl
};
